import classNames from 'classnames';
import React, { useRef, useState, useEffect } from 'react';
import styles from './style.module.scss';
import {
    BudgetIcon,
    CalendarIcon,
    CrossIcon,
    DelIcon,
    DetailIcon,
    EditIcon,
    OptionIcon,
    PencilIcon,
    PlusIcon,
    ProjectManagerIcon,
    ProjectNameIcon,
    StatusCheckIcon,
    TickIcon,
    managerAvatar
} from 'assets';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { tableHeading, tableData, options, optionsConfigure } from './Constant';
import GenericTable from 'shared/components/common/table/table';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import Heading from 'shared/components/common/heading/Heading';
import Switch2 from 'shared/components/common/switch2/Switch2';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import AddSubCategory from 'shared/modal/add_sub_category/AddSubCategory';
import { DeleteSubCategoryMutation, GetAllSubCategoryQuery } from 'shared/services/sub_category_service/SubCategoryService';
import DeleteConfirmation from 'shared/modal/delete_confirmation/DeleteConfirmation';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import { isRestrictActions } from 'shared/utils/Helper';
import SearchBar from 'shared/components/common/searchbar/SearchBar';
export default function ManageSubCategory() {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const { isLoading: DelLoading, mutate: DelMutate, isSuccess } = DeleteSubCategoryMutation();
    const navigate = useNavigate();
    const [milestoneOption, setMileStoneOption] = useState(false);
    const [openProduct, setOpenProduct] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openDelConfirm, setOpenDelConfirm] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const toggleEditUser = () => {
        setIsEdit(!isEdit);
    };
    const closeProductHandler = () => setOpenProduct(false);
    const closeDelConfirmation = () => setOpenDelConfirm(false);
    const [searchMenu, setsearchMenu] = useState('');
    const [clicksearch, setClickSearch] = useState('')
    const [searchResults, setSearchResults] = useState([]);
    const obj = {}
    if (clicksearch) {
        obj['search'] = clicksearch
    }
    const allTaskQueryParams = new URLSearchParams(obj).toString();
    const { isLoading, data, isError, error } = GetAllSubCategoryQuery(allTaskQueryParams);
    const SearchBars = () => {
        if (searchMenu.length > 0) {
            const filteredData = data.filter((user) => user.name.toLowerCase().includes(searchMenu.toLowerCase()));
            setSearchResults(filteredData);
        }
    }
    const [editSubCategoryData, setEditSubCategoryData] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    const handleEditSubCategory = (subcat) => {
        setEditSubCategoryData(subcat);
        setIsEditMode(true);
        setOpenProduct(true);
    };

    const handleCloseSubCategoryModal = () => {
        setOpenProduct(false);
        setEditSubCategoryData(null);
        setIsEditMode(false);
    };

    const columns = React.useMemo(
        () => [
            {
                Header: (
                    <div className={classNames(`${theme}FontColor w-100`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Image
                    </div>
                ),
                accessor: 'image',
                Cell: ({ row }) => (
                    <div className="d-flex align-items-center">
                        {row.original.image ? (
                            <img
                                src={row.original.image}
                                alt={row.original.name}
                                style={{
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '6px',
                                    objectFit: 'cover'
                                }}
                            />
                        ) : (
                            <span>-</span>
                        )}
                    </div>
                )
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor w-100`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Sub Category
                    </div>
                ),
                accessor: 'sku',
                Cell: ({ row }) => <div className="w-100">{row.original.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor w-100`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Category
                    </div>
                ),
                accessor: 'cat',
                Cell: ({ row }) => <div className="w-100">{row.original?.category?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor `)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Category Point
                    </div>
                ),
                accessor: 'category',
                Cell: ({ row }) => <div className="text-center">{row.original.point}</div>
            },

            {
                Header: (
                    <div className={classNames(`${theme}FontColor w-100 text-end me-2`)}>
                        <StatusCheckIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Action
                    </div>
                ),
                accessor: 'status',
                Cell: ({ row }) => (
                    <div className="d-flex justify-content-end align-items-center">
                        <div className="mx-2">
                            <EditIcon
                                className="pointer"
                                onClick={() => {
                                    handleEditSubCategory(row.original);
                                }}
                            />
                        </div>
                        <div className="mx-2">
                            <DelIcon
                                className="pointer"
                                onClick={() => {
                                    if (isRestrictActions(screenEnum.product, screenActionEnum.delete)) {
                                        setOpenDelConfirm(true);
                                        setSelectedItem(row.original);
                                    }
                                }}
                            />
                        </div>
                    </div>
                )
            }
        ],

        [theme, milestoneOption]
    );
    useEffect(() => {
        if (isSuccess) {
            setSelectedItem(null);
            closeDelConfirmation();
        }
        if (data) {
            setSearchResults(data)
        }
    }, [isSuccess, data, searchMenu]);
    return (
        <div className={classNames(styles.UserContainer, 'text-start')}>
            <SearchBar
                searchKey="name"
                suggestionsSource={data}
                onSearchChange={setSearchResults} // ✅ REQUIRED!
            />
            <div className={styles.Header}>
                <Heading heading={'Manage Sub Category'} headingStyle={styles.Heading} />
                <div className="d-flex">
                    <CustomButton
                        Icon={PlusIcon}
                        IconStyle={classNames('me-1', styles.IconStyle)}
                        text={'Sub Category'}
                        submitHandle={() => {
                            if (isRestrictActions(screenEnum.product, screenActionEnum.create)) {
                                setEditSubCategoryData(null);
                                setIsEditMode(false);
                                setOpenProduct(true);
                            }
                        }}
                        containerStyle={classNames(styles.AddProduct)}
                    />
                </div>
            </div>
            <GenericTable columns={columns} data={searchResults || []} TDTextStyle={classNames(styles.TDTextStyle)} TableWrapperStyle={classNames(styles.Table)} />
            <AddSubCategory
                show={openProduct}
                datatable={data}
                isEdit={isEditMode}
                editData={editSubCategoryData}
                handleClose={handleCloseSubCategoryModal}
            />
            <DeleteConfirmation
                show={openDelConfirm}
                loading={DelLoading}
                ConfimationHeading="Delete Sub Category"
                Desc={'Are you sure you want to delete the Sub Category?'}
                DeleteHandler={() => {
                    DelMutate(selectedItem?._id);
                }}
                handleClose={closeDelConfirmation}
            />
            {isLoading && <OverlayLoading />}
        </div>
    );
}
